import React, { useState } from "react";
import subLeftIcon from "../../../images/icon/sub-left-icon.png";
import subRightIcon from "../../../images/icon/sub-right-icon.png";

interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    id: 1,
    question: "How cheap are your SMM services?",
    answer:
      "Prices start from $0.01 per 1000 on many services. Resellers can stay cheap and still keep a strong margin. Bulk orders and API users get the best rates on every platform.",
  },
  {
    id: 2,
    question: "How fast do orders start and finish?",
    answer:
      "Most orders start in a few seconds. Instagram likes, TikTok views, and YouTube views usually finish in minutes or a few hours. Larger orders split over time to stay safe and stable.",
  },
  {
    id: 3,
    question: "Is buying followers and views safe for my account?",
    answer:
      "Yes. We use safe delivery methods and avoid suspicious patterns. Our services are built for creators, brands, and resellers. Always pair orders with real content for the best results.",
  },
  {
    id: 4,
    question: "What payment methods and minimum deposit do you accept?",
    answer:
      "We accept cards, USDT, and other popular methods. Minimum deposit is low so new resellers can start with a small budget. Top up in minutes and place your first order right away.",
  },
  {
    id: 5,
    question: "Do you offer refill, cancel, and a free API?",
    answer:
      "Yes. Many services have refill on drops. You can also cancel pending orders in the dashboard. Our reseller API is free. Plug it into your store and start selling in a few minutes.",
  },
];

const FAQSection: React.FC = () => {
  const [activeId, setActiveId] = useState<number | null>(1);

  const toggleFAQ = (id: number) => {
    setActiveId(activeId === id ? null : id);
  };

  return (
    <section
      id="faq"
      className="faq pos-rel pt-145 pb-150 bg_img"
    >
      <div className="container">
        {/* Section Title */}
        <div className="sec-title sec-title--two pricing-sec-title text-center mb-50">
          <span
            className="sub-title mb-25 wow fadeInUp"
            data-wow-duration="600ms"
          >
            <img src={subLeftIcon} alt="icon" /> FAQ’s{" "}
            <img src={subRightIcon} alt="icon" />
          </span>
          <h2
            className="title wow fadeInUp"
            data-wow-delay="150ms"
            data-wow-duration="600ms"
          >
            Common questions from resellers
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div className="row">
          <div className="col-lg-12">
            <div className="xb-faq wow fadeInUp" data-wow-duration="600ms">
              <ul className="accordion_box clearfix list-unstyled">
                {faqs.map((faq, index) => (
                  <li
                    key={faq.id}
                    className={`accordion block ${
                      activeId === faq.id ? "active-block" : ""
                    }`}
                  >
                    {/* Question Button */}
                    <div
                      className={`acc-btn ${
                        activeId === faq.id ? "active" : ""
                      }`}
                      onClick={() => toggleFAQ(faq.id)}
                    >
                      <span className="number">
                        {index + 1 < 10 ? `0${index + 1}` : index + 1}
                      </span>
                      _ {faq.question}
                      <span className="arrow">
                        <span></span>
                      </span>
                    </div>

                    {/* Answer Body */}
                    <div
                      className={`acc_body ${
                        activeId === faq.id ? "current" : ""
                      }`}
                      style={{
                        maxHeight: activeId === faq.id ? "300px" : "0px",
                        overflow: "hidden",
                        transition: "max-height 0.4s ease",
                      }}
                    >
                      <div className="content">
                        <p>{faq.answer}</p>
                        <ul className="list-unstyled">
                          <li>
                            <i className="far fa-check"></i> Low prices from
                            $0.01 per 1000 orders.
                          </li>
                          <li>
                            <i className="far fa-check"></i> Fast delivery
                            on every platform we support.
                          </li>
                          <li>
                            <i className="far fa-check"></i> Free API, refill,
                            and 24/7 real support.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Shape */}
      <span className="faq-linear-shape"></span>
    </section>
  );
};

export default FAQSection;
